module.exports = __webpack_public_path__ + "img/astral-txt_13.f0a022bc.svg";